import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'My Importers',
		url: '/importers',
		icon: 'suitcase',
	},
];

export default class Importers extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button data-id="add-importer" onClick={this.toggle('modalImporter')} size="sm" color="primary">
						<i className="fa fa-suitcase"/>&nbsp;&nbsp;Add Importer
					</Button>
				</Framework.Components.PageBar>

				<Collections.Importers
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name={"Importer"}
					object={Objects.Importer}
					history={this.props.history}
					toggle={this.state['modalImporter']}
					reportClose={this.reportClose('modalImporter')}
					afterSave={this.handleAfterSave}
					size={'lg'}
				/>

			</div>
		);
	}
}
